import { EOnboardingDiscoverySource } from '@constants';
import { Form } from 'antd';

import { StepWrapper } from '../../../styles';
import { TranslatedTitle } from '../components';

import { ReasonRadio } from '@/components/Onboarding';

export const DiscoverSources = () => {
  return (
    <StepWrapper>
      <TranslatedTitle i18nKey="DISCOVER_SOURCES" />
      <Form.Item rules={[{ required: true, message: '' }]} name={['onBoarding', 'discoverySource']}>
        <ReasonRadio options={Object.values(EOnboardingDiscoverySource)} />
      </Form.Item>
    </StepWrapper>
  );
};
